import { Link, PathMatch, matchPath } from "react-router-dom";
import { SmileyHouseIcon } from "../icons/SmileyHouseIcon";
import UilAPIConfig from "@iconscout/react-unicons/icons/uil-cloud-computing";
import UilBooks from "@iconscout/react-unicons/icons/uil-books";
import UilFileGraph from "@iconscout/react-unicons/icons/uil-file-graph";
import UilFolder from "@iconscout/react-unicons/icons/uil-folder";
import UilHome from "@iconscout/react-unicons/icons/uil-home";
import UilParsing from "@iconscout/react-unicons/icons/uil-file-check-alt";
import UilProgram from "@iconscout/react-unicons/icons/uil-box";
import UilRocket from "@iconscout/react-unicons/icons/uil-rocket";
import UilUser from "@iconscout/react-unicons/icons/uil-user-check";
import UilCog from "@iconscout/react-unicons/icons/uil-cog";
import UilBuilding from "@iconscout/react-unicons/icons/uil-building";
import UilBell from "@iconscout/react-unicons/icons/uil-bell";
import UilSuitcase from "@iconscout/react-unicons/icons/uil-suitcase";
import UilMail from "@iconscout/react-unicons/icons/uil-mailbox";
import UilReceipt from "@iconscout/react-unicons/icons/uil-receipt";
import UilMonitor from "@iconscout/react-unicons/icons/uil-monitor-heart-rate";
import { isValidRouteParam } from "components/SelectHqOfficeCombobox/helper";
import { GuardedMenuItem, GuardedSubMenu } from "../MenuGuards";
import { useProSidebar } from "react-pro-sidebar";
import { SolidNewspaper } from "@adfenix/icons";
import { SRegularEnvelope } from "@adfenix/icons";
import { SRegularFile } from "@adfenix/icons";
import { SRegularReceipt } from "@adfenix/icons";

export const BackOfficeLinks = () => {
  const matchHqPath: PathMatch<"hqId"> | null = matchPath(
    { path: "/back-office/hq/:hqId", end: false },
    location.pathname
  );
  const matchHqAndOfficePath: PathMatch<"hqId" | "officeId"> | null = matchPath(
    { path: "/back-office/hq/:hqId/office/:officeId", end: false },
    location.pathname
  );
  const { toggleSidebar } = useProSidebar();

  const hqId = matchHqPath?.params.hqId ?? "";
  const officeId = matchHqAndOfficePath?.params.officeId ?? "";

  const hqIsOpen =
    matchHqPath !== null && isValidRouteParam(hqId) && !matchHqAndOfficePath;

  const officeIsOpen =
    matchHqAndOfficePath !== null &&
    isValidRouteParam(matchHqAndOfficePath.params.hqId ?? "") &&
    isValidRouteParam(matchHqAndOfficePath.params.officeId ?? "");

  const matchesRoute = (route: string) =>
    matchPath(route, location.pathname)?.pattern.end;

  return (
    <>
      <GuardedSubMenu
        requiredPermission={["Admin", "View"]}
        icon={<UilCog />}
        defaultOpen={hqIsOpen}
        label="HQ Settings"
        active={hqIsOpen}
        className="sidebar-top-menu-item"
      >
        {/* Add HQ links here */}
        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          active={matchesRoute("/back-office/hq/:hqId/hq-settings")}
          icon={<UilCog />}
          className="sidebar-sub-menu-item"
          component={
            <Link to={`/back-office/hq/${hqId ? hqId : ":hqId"}/hq-settings`} />
          }
        >
          Account
        </GuardedMenuItem>
        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={<UilRocket />}
          active={matchesRoute("/back-office/hq/:hqId/boost/:page")}
          className="sidebar-sub-menu-item"
          component={
            <Link
              to={`/back-office/hq/${hqId ? hqId : ":hqId"}/boost/publishing`}
            />
          }
        >
          Boost
        </GuardedMenuItem>
        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={<UilProgram />}
          active={
            matchesRoute("/back-office/hq/:hqId/program-builder/:programId") ||
            matchesRoute("/back-office/hq/:hqId/program-builder")
          }
          className="sidebar-sub-menu-item"
          component={
            <Link
              to={`/back-office/hq/${hqId ? hqId : ":hqId"}/program-builder`}
            />
          }
        >
          Program Builder
        </GuardedMenuItem>
        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={<SmileyHouseIcon dark />}
          active={matchesRoute("/back-office/hq/:hqId/engage/:page")}
          className="sidebar-sub-menu-item"
          component={
            <Link
              to={`/back-office/hq/${hqId ? hqId : ":hqId"}/engage/general`}
            />
          }
        >
          Engage
        </GuardedMenuItem>
        <GuardedMenuItem
          requiredPermission={["DatabaseBuilder", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={<UilParsing />}
          active={matchesRoute("/back-office/hq/:hqId/database-builder/:page")}
          className="sidebar-sub-menu-item"
          component={
            <Link
              to={`/back-office/hq/${
                hqId ? hqId : ":hqId"
              }/database-builder/attributes`}
            />
          }
        >
          Database builder
        </GuardedMenuItem>
        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={<UilMail />}
          active={matchesRoute("/back-office/hq/:hqId/email-config")}
          className="sidebar-sub-menu-item"
          component={
            <Link
              to={`/back-office/hq/${hqId ? hqId : ":hqId"}/email-config`}
            />
          }
        >
          Email
        </GuardedMenuItem>
        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={
            <SRegularFile style={{ height: "16px" }} fill={"currentColor"} />
          }
          active={matchesRoute("/back-office/hq/:hqId/templates/:page")}
          className="sidebar-sub-menu-item"
          component={
            <Link
              to={`/back-office/hq/${
                hqId ? hqId : ":hqId"
              }/templates/campaign-ad`}
            />
          }
        >
          Templates
        </GuardedMenuItem>

        <GuardedMenuItem
          requiredPermission={["Admin", "Edit"]}
          onClick={() => toggleSidebar(false)}
          icon={<UilHome />}
          active={matchesRoute("/back-office/hq/:hqId/offices")}
          className="sidebar-sub-menu-item"
          component={
            <Link to={`/back-office/hq/${hqId ? hqId : ":hqId"}/offices`} />
          }
        >
          Offices
        </GuardedMenuItem>
        <GuardedMenuItem
          requiredPermission={["Admin", "Edit"]}
          onClick={() => toggleSidebar(false)}
          icon={<UilAPIConfig />}
          active={matchesRoute("/back-office/hq/:hqId/api-config")}
          className="sidebar-sub-menu-item"
          component={
            <Link to={`/back-office/hq/${hqId ? hqId : ":hqId"}/api-config`} />
          }
        >
          API
        </GuardedMenuItem>

        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={<SolidNewspaper fill="currentColor" />}
          active={matchesRoute("/back-office/hq/:hqId/delta-configuration/")}
          className="sidebar-sub-menu-item"
          component={
            <Link
              to={`/back-office/hq/${
                hqId ? hqId : ":hqId"
              }/delta-configuration`}
            />
          }
        >
          Delta
        </GuardedMenuItem>
        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={<SRegularReceipt fill="currentColor" />}
          active={
            location.pathname === "/back-office/hq/:hqId/log" ? true : undefined
          }
          className="sidebar-sub-menu-item"
          component={
            <Link to={`/back-office/hq/${hqId ? hqId : ":hqId"}/log`} />
          }
        >
          Log
        </GuardedMenuItem>
      </GuardedSubMenu>

      <GuardedSubMenu
        requiredPermission={["Admin", "View"]}
        defaultOpen={officeIsOpen}
        label="Office Settings"
        active={officeIsOpen}
        icon={<UilCog />}
        className="sidebar-top-menu-item"
      >
        {/* Add office links here */}

        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={<UilCog />}
          className="sidebar-sub-menu-item"
          active={matchesRoute(
            "/back-office/hq/:hqId/office/:officeId/office-settings"
          )}
          component={
            <Link
              to={`/back-office/hq/${hqId ? hqId : ":hqId"}/office/${
                officeId ? officeId : ":officeId"
              }/office-settings`}
            />
          }
        >
          Account
        </GuardedMenuItem>

        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={<UilRocket />}
          className="sidebar-sub-menu-item"
          active={matchesRoute(
            "/back-office/hq/:hqId/office/:officeId/boost/:page"
          )}
          component={
            <Link
              to={`/back-office/hq/${hqId ? hqId : ":hqId"}/office/${
                officeId ? officeId : ":officeId"
              }/boost/publishing`}
            />
          }
        >
          Boost
        </GuardedMenuItem>

        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={<SmileyHouseIcon dark />}
          className="sidebar-sub-menu-item"
          active={matchesRoute(
            "/back-office/hq/:hqId/office/:officeId/engage/:page"
          )}
          component={
            <Link
              to={`/back-office/hq/${hqId ? hqId : ":hqId"}/office/${
                officeId ? officeId : ":officeId"
              }/engage/capture`}
            />
          }
        >
          Engage
        </GuardedMenuItem>

        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={<UilMail />}
          className="sidebar-sub-menu-item"
          active={matchesRoute(
            "/back-office/hq/:hqId/office/:officeId/email-config/"
          )}
          component={
            <Link
              to={`/back-office/hq/${hqId ? hqId : ":hqId"}/office/${
                officeId ? officeId : ":officeId"
              }/email-config`}
            />
          }
        >
          Email
        </GuardedMenuItem>
        <GuardedMenuItem
          requiredPermission={["Admin", "View"]}
          onClick={() => toggleSidebar(false)}
          icon={<SRegularReceipt fill="currentColor" />}
          active={matchesRoute("/back-office/hq/:hqId/office/:officeId/log")}
          className="sidebar-sub-menu-item"
          component={
            <Link
              to={`/back-office/hq/${hqId ? hqId : ":hqId"}/office/${
                officeId ? officeId : ":officeId"
              }/log`}
            />
          }
        >
          Log
        </GuardedMenuItem>
      </GuardedSubMenu>

      <GuardedMenuItem
        requiredPermission={["Admin", "View"]}
        onClick={() => toggleSidebar(false)}
        icon={<UilBuilding />}
        className="sidebar-top-menu-item"
        active={
          location.pathname.startsWith("/back-office/listing")
            ? true
            : undefined
        }
        component={<Link to={"/back-office/listing"} />}
      >
        Listings
      </GuardedMenuItem>

      <GuardedMenuItem
        requiredPermission={["Admin", "View"]}
        icon={<UilFolder />}
        className="sidebar-top-menu-item"
        active={
          location.pathname.startsWith("/back-office/campaign")
            ? true
            : undefined
        }
        component={<Link to="/back-office/campaign" />}
      >
        Campaigns
      </GuardedMenuItem>

      <GuardedMenuItem
        requiredPermission={["Admin", "View"]}
        icon={<UilReceipt />}
        className="sidebar-top-menu-item"
        active={
          location.pathname.startsWith("/back-office/order") ? true : undefined
        }
        component={<Link to="/back-office/order" />}
      >
        Orders
      </GuardedMenuItem>

      <GuardedMenuItem
        requiredPermission={["Admin", "Edit"]}
        onClick={() => toggleSidebar(false)}
        icon={<UilBooks />}
        active={matchesRoute("/back-office/program-instance")}
        className="sidebar-top-menu-item"
        component={<Link to={`/back-office/program-instance`} />}
      >
        Program Instances
      </GuardedMenuItem>

      <GuardedMenuItem
        requiredPermission={["Admin", "View"]}
        icon={<UilUser />}
        className="sidebar-top-menu-item"
        active={
          location.pathname.startsWith("/back-office/agent-profile")
            ? true
            : undefined
        }
        component={<Link to="/back-office/agent-profiles" />}
      >
        Agent profiles
      </GuardedMenuItem>

      <GuardedMenuItem
        requiredPermission={["UserManagement", "View"]}
        onClick={() => toggleSidebar(false)}
        icon={<UilUser />}
        active={location.pathname === "/back-office/users" ? true : undefined}
        className="sidebar-top-menu-item"
        component={<Link to={"/back-office/users"} />}
      >
        Users
      </GuardedMenuItem>

      <GuardedMenuItem
        requiredPermission={["RoleManagement", "View"]}
        onClick={() => toggleSidebar(false)}
        icon={<UilSuitcase />}
        active={location.pathname === "/back-office/role" ? true : undefined}
        className="sidebar-top-menu-item"
        component={<Link to={"/back-office/role"} />}
      >
        Roles
      </GuardedMenuItem>

      <GuardedMenuItem
        requiredPermission={["Admin", "Edit"]}
        onClick={() => toggleSidebar(false)}
        icon={<UilBell />}
        active={location.pathname === "/back-office/alerts" ? true : undefined}
        className="sidebar-top-menu-item"
        component={<Link to={"/back-office/alerts"} />}
      >
        Alerts
      </GuardedMenuItem>

      <GuardedMenuItem
        requiredPermission={["BillingReports", "View"]}
        onClick={() => toggleSidebar(false)}
        icon={<UilFileGraph />}
        className="sidebar-top-menu-item"
        active={
          location.pathname === "/back-office/billing-report" ? true : undefined
        }
        component={<Link to={"/back-office/billing-report"} />}
      >
        Billing Reports
      </GuardedMenuItem>

      <GuardedMenuItem
        requiredPermission={["Admin", "Edit"]}
        onClick={() => toggleSidebar(false)}
        icon={<UilMonitor />}
        active={matchesRoute("/back-office/monitoring")}
        className="sidebar-top-menu-item"
        component={<Link to={`/back-office/monitoring`} />}
      >
        Monitoring
      </GuardedMenuItem>
      <GuardedSubMenu
        requiredPermission={["Admin", "View"]}
        icon={
          <SRegularEnvelope
            width="20px"
            height={"20px"}
            fill={"currentColor"}
          />
        }
        defaultOpen={hqIsOpen}
        label="Email"
        active={
          matchesRoute("/back-office/email") ||
          matchesRoute("/back-office/template")
        }
        className="sidebar-top-menu-item"
      >
        <GuardedMenuItem
          requiredPermission={["Admin", "Edit"]}
          onClick={() => toggleSidebar(false)}
          icon={<SRegularEnvelope fill={"currentColor"} />}
          active={matchesRoute("/back-office/email-types")}
          className="sidebar-top-menu-item"
          component={<Link to={`/back-office/email-types`} />}
        >
          Types
        </GuardedMenuItem>
        <GuardedMenuItem
          requiredPermission={["Admin", "Edit"]}
          onClick={() => toggleSidebar(false)}
          icon={<SRegularFile fill={"currentColor"} />}
          active={matchesRoute("/back-office/email-templates")}
          className="sidebar-top-menu-item"
          component={<Link to={`/back-office/email-templates`} />}
        >
          Templates
        </GuardedMenuItem>
      </GuardedSubMenu>
      {/* available only on link for now */}
      {/* 
      <GuardedMenuItem
        requiredPermission={["Admin", "Edit"]}
        onClick={() => toggleSidebar(false)}
        active={matchesRoute("/back-office/custom-campaign")}
        className="sidebar-sub-menu-item"
        component={<Link to={`/back-office/custom-campaign`} />}
      >
        Custom campaigns
      </GuardedMenuItem> */}
    </>
  );
};
